export default __webpack_public_path__ + "assets/googleplay_bt.0622846d.svg";